import "./LendingSolutions.module.css";
import Header from "@/reusable_sections/Header";
import TailoredLoanPrograms from "./sections/TailoredLoanPrograms";
import ThePathToClosing from "./sections/ThePathToClosing";
import ReadyToStart from "./sections/ReadyToStart";
import Footer from "@/reusable_sections/Footer";
export default function LendingSolutionsPage() {
  return <div>
      <Header />
      <TailoredLoanPrograms />
      <ThePathToClosing />
      <ReadyToStart />
      <Footer />
    </div>;
}